// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"60b6c993","74":"b0a047b2","146":"4c262b3e","173":"6d2dc0b1","226":"6a3441d9","396":"ab9beb7a","629":"ef82a4aa","646":"cbcd194b","715":"138adca9","719":"15b31e32","821":"507c6a6d","845":"4a9947d6","897":"eb5b551e","915":"cd717716"}[chunkId] + ".chunk.js";
};